import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useAuthentication } from "../hooks/useAuthentication";
import { USER_PERMISSIONS } from "../constants/user-permissions";
import { useDispatch } from 'react-redux';
import { logout } from '../context/redux/slicers/authSlice';

const GuardPermissions = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, userRole } = useAuthentication();

  if (!isAuthenticated) {
    return children;
  }

  if (USER_PERMISSIONS[userRole] === undefined) {
    dispatch(logout());
    return children;
  }

  const hasPermission = USER_PERMISSIONS[userRole]?.some((route) => location.pathname.startsWith(route));

  if (!hasPermission) {
    const defaultPath = USER_PERMISSIONS[userRole][0];
    return <Navigate to={defaultPath} />;
  }

  return children;
};

export default GuardPermissions;